import * as ACTION_TYPES from './auditActionTypes';

// Actions list actions
export const getAuditListRequest = () => ({
	type: ACTION_TYPES.LIST_AUDIT_REQUEST
});

export const getAuditListRequestSuccess = data => ({
	type: ACTION_TYPES.LIST_AUDIT_REQUEST_SUCCESS,
	payload: {
		data
	}
});

export const getAuditListRequestFailure = error => ({
	type: ACTION_TYPES.LIST_AUDIT_REQUEST_FAILURE,
	payload: {
		error
	}
});

export const clearAuditList = () => ({
	type: ACTION_TYPES.CLEAR_AUDIT_LIST
});
// END Actions list actions

// list audits users actions
export const getAuditsUsersListRequest = () => ({
	type: ACTION_TYPES.LIST_AUDITS_USERS_REQUEST
});

export const getAuditsUsersListRequestSuccess = data => ({
	type: ACTION_TYPES.LIST_AUDITS_USERS_REQUEST_SUCCESS,
	payload: {
		data
	}
});

export const getAuditsUsersListRequestFailure = error => ({
	type: ACTION_TYPES.LIST_AUDITS_USERS_REQUEST_FAILURE,
	payload: {
		error
	}
});

export const clearAuditsUsersList = () => ({
	type: ACTION_TYPES.CLEAR_AUDITS_USERS_LIST
});
// END list audits users actions

// treasury audit list actions
export const getTreasuryAuditListRequest = () => ({
	type: ACTION_TYPES.LIST_TREASURY_AUDIT_REQUEST
});

export const getTreasuryAuditListRequestSuccess = data => ({
	type: ACTION_TYPES.LIST_TREASURY_AUDIT_REQUEST_SUCCESS,
	payload: { data }
});

export const getTreasuryAuditListRequestFailure = error => ({
	type: ACTION_TYPES.LIST_TREASURY_AUDIT_REQUEST_FAILURE,
	payload: { error }
});

export const clearTreasuryAuditList = () => ({
	type: ACTION_TYPES.CLEAR_TREASURY_AUDIT_LIST
});

// treasury audit detail actions
export const getTreasuryAuditDetailRequest = () => ({
	type: ACTION_TYPES.GET_TREASURY_AUDIT_DETAIL_REQUEST
});

export const getTreasuryAuditDetailRequestSuccess = data => ({
	type: ACTION_TYPES.GET_TREASURY_AUDIT_DETAIL_REQUEST_SUCCESS,
	payload: { data }
});

export const getTreasuryAuditDetailRequestFailure = error => ({
	type: ACTION_TYPES.GET_TREASURY_AUDIT_DETAIL_REQUEST_FAILURE,
	payload: { error }
});

export const clearTreasuryAuditDetail = () => ({
	type: ACTION_TYPES.CLEAR_TREASURY_AUDIT_DETAIL
});
// END treasury audit actions